<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import { route } from "ziggy-js";
import { computed, ref, watch } from "vue";
let props = defineProps({
    markdown: String,
})

let computedMarkdown = computed(()=>{
    //wherever there is a call to the route function in the markdown, replace with the actual value
    return props.markdown.replace(/route\(([^)]+)\)/g, (match, p1) => {
        return route(p1);
    })
})

let markdownTemplate = ref();


let tables = computed(()=>{
    if(typeof window !== "undefined") {
        let tables = markdownTemplate.value?.$el?.getElementsByTagName?.("table");
        if(tables){
            return tables
        }
    }
    return [];
})

watch(tables, (newVal)=>{
    for(let table of newVal){
        let ths = table.getElementsByTagName("th");
        // get text of each th and add it as a data-label attribute onto the cells of the table
        for(let i = 0; i < ths.length; i++){
            let th = ths[i];
            let dataLabel = th.innerText;
            let tds = table.getElementsByTagName("td");
            for(let td of tds){
                if(td.cellIndex === i){
                    td.setAttribute("data-label", dataLabel);
                }
            }
        }
    }
}, {deep: true})
</script>
<template>
    <VueShowdown ref="markdownTemplate" :markdown="computedMarkdown" vue-template :vue-template-components="{
        Link
    }"/>
</template>